import React from 'react'

import type { TableHeaders } from '@fourthwall/components'
import { PriceString, ProfitString } from '@fourthwall/components'
import { TimezonedDateString } from '@modules/Timezone/components/TimezonedDateString'

import type { Transaction } from '../../Transactions.types'
import { transactionTypeTexts } from '../../consts'
import { TransactionIdLink } from '../TransactionIdLink/TransactionIdLink'

export const getHeaders = (timezoneAbbreviation: string): TableHeaders<Transaction> => [
  {
    id: 'date',
    label: `Date (${timezoneAbbreviation})`,
    render: ({ transactionAt }) => (
      <div style={{ lineHeight: '24px' }}>
        <TimezonedDateString date={transactionAt} format="MM/DD/YYYY" />
        <br />
        <TimezonedDateString
          date={transactionAt}
          format="h:mm A"
          withTimezoneAbbreviation={false}
        />
      </div>
    ),
  },
  {
    id: 'id',
    label: 'ID',
    render: (row) => <TransactionIdLink transaction={row} />,
  },
  {
    id: 'type',
    label: 'Transaction type',
    render: ({ type }) => transactionTypeTexts[type],
  },
  {
    id: 'profit',
    label: 'Profit/Cost',
    render: ({ value, type }) => {
      if (type === 'CREATOR_CHARGE') {
        return <PriceString value={value.value} />
      }

      return <ProfitString value={value.value} />
    },
  },
  {
    id: 'balance',
    label: (
      <>
        Balance after
        <br />
        transaction
      </>
    ),
    render: ({ balance }) => <PriceString value={balance.value} />,
  },
]
